/**
 * The one unit conversion in the whole app.
 *
 * Everything in `src/kitchen/` is in MILLIMETRES: the room, the runs, the cabinets, the
 * rules, the schedule, the price. three.js is in metres, because that is what its lights,
 * its shadow cameras and its physically-based materials are calibrated for. So there is
 * exactly one multiplication, applied at the edge where geometry is made, and nowhere else.
 *
 * It lived in build.js, which was right until appliance.js needed it too and importing it
 * from build.js would have made the two files import each other. A constant with no
 * dependencies belongs in a file with no dependencies.
 */
export const MM = 0.001
